import React, { Component } from 'react';


export default class CustomerOrderedProduct extends Component {
	render() {
		const product = this.props.product;
		return (
			<div className="user-order-history-order">
				<div className="user-product-container">
					<div className="product-info product-image"><img alt={ product.name } src={ product.coverImageSource } /></div>
	                <div className="product-info-group">
	                    <div className="product-info product-price">{ '$' + product.price.slice(0,-2) }</div>
	                    <div className="product-info product-name">{ product.name }</div>
	                    <div className="product-info product-id">Product id: <span>{ product.id }</span></div>
	                </div>
				</div>
				<div className="user-order-history-rating">Rating: { product.rating !== null ? product.rating : "Not rated" }</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/customersuccessportal/CustomerOrderedProduct.js